import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ToastItem, ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-toast-outlet',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div
      class="pointer-events-none fixed right-4 top-24 z-[70] flex w-full max-w-sm flex-col gap-3"
      data-testid="toast-container"
    >
      @for (toast of toastService.toasts(); track toast.id) {
        <div
          class="pointer-events-auto rounded-xl border px-4 py-3 shadow-lg backdrop-blur-sm"
          [class]="toastClasses(toast)"
          [attr.role]="toast.tone === 'error' ? 'alert' : 'status'"
          [attr.aria-live]="toast.tone === 'error' ? 'assertive' : 'polite'"
          [attr.data-testid]="'toast-' + toast.tone + '-' + toast.id"
        >
          <div class="flex items-start gap-3">
            <div class="min-w-0 flex-1 text-sm font-medium leading-5">
              {{ toast.message }}
            </div>
            <button
              type="button"
              class="shrink-0 text-current/80 transition hover:text-current"
              data-testid="toast-dismiss-button"
              (click)="toastService.dismiss(toast.id)"
              aria-label="Dismiss notification"
            >
              <svg class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path
                  fill-rule="evenodd"
                  d="M4.22 4.22a.75.75 0 011.06 0L10 8.94l4.72-4.72a.75.75 0 111.06 1.06L11.06 10l4.72 4.72a.75.75 0 11-1.06 1.06L10 11.06l-4.72 4.72a.75.75 0 11-1.06-1.06L8.94 10 4.22 5.28a.75.75 0 010-1.06z"
                  clip-rule="evenodd"
                />
              </svg>
            </button>
          </div>
        </div>
      }
    </div>
  `,
})
export class ToastOutletComponent {
  protected readonly toastService = inject(ToastService);

  protected toastClasses(toast: ToastItem): string {
    switch (toast.tone) {
      case 'success':
        return 'border-[#0073cf]/25 bg-[#0073cf] text-white';
      case 'warning':
        return 'border-amber-300 bg-amber-100 text-amber-900';
      case 'error':
        return 'border-red-300 bg-red-100 text-red-900';
    }
  }
}
